{
    "Profile_Payment.paymentMode": "Payment Mode",
    "Profile_Payment.paymentStatus": "Payment Status",
    "Profile_Payment.paymentDetails": "Payment details",
    "Profile_Payment.paymentAmount": "Payment Amount",
    "Profile_Payment.success": "Success",
    "Profile_Payment.incomplete": "Incomplete",
    "Profile_Payment.paymentCompletedFullAmount": "Payment Completed for full Amount",
    "Profile_Payment.downpaymentReceived": "Downpayment Received",
    "Profile_Payment.bankAccountInfoSuccess": "The process to capture the bank account information was successful",
    "Profile_Payment.monthlySubscriptionSuccess": "The monthly subscription has been successfully created",
    "Profile_Payment.downpaymentAmount": "Downpayment Amount",
    "Profile_Payment.monthlyAmount": "Monthly Amount",
    "Profile_Payment.startDateMonthlyCharges": "Start Date of Monthly charges",
    "Profile_Payment.failedReasonDebit": "Failed Reason for Debit",
    "Profile_Payment.paymentTransfer": "Payment Transfer",
    "Profile_Payment.transferDetails": "Transfer Details",
    "Profile_Payment.transferredAmount": "Transferred Amount",
    "Profile_Payment.transferredDate": "Transferred Date",
    "Profile_Payment.transferReferenceCode": "Transfer Reference Code",
    "Profile_Payment.sectionHeader": "Payment",
    "Profile_Payment.formHeader": "Payment Information",
    "Profile_Payment.paymentPlan": "Payment Plan",
    "Profile_Payment.authorizationHeader": "Authorization",
    "Profile_Payment.authorizationInformation": "Authorization Information",
    "Profile_Payment.authorizedCreditCardChargeAmount": "Authorized Amount",
    "Profile_Payment.authorizationStatus": "Status",
    "Profile_Payment.authorizationFailedReason": "Failed Reason",
    "Profile_Payment.authorizedOn": "Authorized On",
    "Profile_Payment.authorizationExpiresOn": "Expires On",
    "Profile_Payment.receivePaymentExpiryDate": "Receive Payment Expiry Date",
    "Profile_Payment.refundHeader": "Refund",
    "Profile_Payment.refundInformation": "Refund Information",
    "Profile_Payment.refundDate": "Refund Date",
    "Profile_Payment.refundAmount": "Refund Amount",
    "Profile_Payment.refundReference": "Refund Reference",
    "Profile_Payment.refundDescription": "Refund Description",
    "Profile_Payment.refundMethod": "Refund Method",
    "Profile_Payment.refundMethodStripe": "Stripe",
    "Profile_Payment.refundMethodBankTransfer": "Bank Transfer",
    "Profile_Payment.refundMethodCheck": "Check",
    "Profile_Payment.refundMethodOther": "Other"
}
